import EnqueryForm from "@/components/forms/EnqueryForm";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import Image from "next/image";
import React from "react";

const CourseTag = ({ label }: { label: string }) => (
  <span className="md:hidden relative inline-flex items-center shrink-0 h-[30px] w-[174px] -ml-4 mb-2">
    <svg
      className="absolute left-0 top-0"
      width="174"
      height="30"
      viewBox="0 0 174 30"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M0 0H162L174 15L162 30H0V0Z" fill="#336297" />
    </svg>
    <svg
      className="absolute left-0 top-0"
      width="168"
      height="30"
      viewBox="0 0 168 30"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M0 0H156L168 15L156 30H0V0Z" fill="url(#cma_course_tag)" />
      <defs>
        <linearGradient
          id="cma_course_tag"
          x1="0"
          y1="15"
          x2="163"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#164B7F" />
          <stop offset="1" stopColor="#0B2A4D" />
        </linearGradient>
      </defs>
    </svg>
    <span className="relative z-10 pl-4 text-white text-[12px] font-bold uppercase tracking-[2px] leading-none">
      {label}
    </span>
  </span>
);

const MilesCpaBanner = () => {
  return (
    <section className="w-full bg-white md:pb-6 md:pt-16 ">
      <div className=" md:max-w-[1340px] lg:px-7 mx-auto">
        {/* ── Gradient rounded card ── */}
        <div
          className="overflow-hidden rounded-[28px] md:rounded-[50px]"
          style={{
            background: "linear-gradient(270deg, #CEE6FF 0%, #F1F8FF 100%)",
          }}
        >
          <div className="grid grid-cols-[2fr_2fr] md:grid-cols-[minmax(0,1fr)_minmax(240px,0.8fr)_minmax(320px,0.9fr)] md:items-stretch md:min-h-[380px]">
            {/* ── TEXT ── */}
            <div className="col-start-1 row-start-1 flex flex-col justify-center pl-4 pt-6 pb-2 md:items-start md:text-left md:px-10 md:py-10">
              {/* mobile ribbon badge */}
              <CourseTag label="MILES CPA" />
              {/* desktop plain-text label */}
              <p className="hidden md:block text-[16px] font-bold uppercase tracking-[2px]">
                <span className="text-[#333] tracking-[2px]">MILES</span>{" "}
                <span className="text-[#39F] tracking-[2px]">CPA</span>
              </p>
              <h1 className="text-[#39F] text-[22px] md:text-[24px] font-bold leading-[1.2] mb-2 md:mb-5">
                Join India’s #1 CPA Ecosystem | 80%+ of CPAs in India are Miles
                Alumni
              </h1>
              <p className="text-[#333] text-sm max-w-[180px] leading-[1.2] md:leading-normal md:max-w-[360px]">
                Build your global journey with Miles CPA! With world-class
                coaching from Varun Jain, expert mentorship, and CAIRA
                AI-Readiness, Miles Education CPA transforms you into a
                high-earning finance leader. Enroll today!
              </p>
            </div>

            {/* ── BANNER IMAGE ── */}
            <div className="col-start-2 row-start-1 flex items-end justify-center">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/seo-pages/miles-cma/miles-cma-hero-mob.webp"
                alt="miles CPA banner image"
                width={200}
                height={230}
                className="md:hidden object-contain w-full max-w-[260px]"
                priority
              />
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/seo-pages/miles-cma/miles-cma-hero.webp"
                alt="miles CPA banner image"
                width={380}
                height={400}
                className="hidden md:block object-contain w-auto md:max-w-none md:h-[350px]"
                priority
              />
            </div>

            {/* ── FORM ── */}
            <div className="col-span-2 row-start-2 md:col-span-1 md:row-start-1 flex items-center justify-center px-4 pb-5 md:px-6 md:py-8">
              <div className="relative z-10 bg-white rounded-2xl border border-[#DEE7F5] shadow-sm p-4 w-full max-w-[420px] md:max-w-none">
                <EnqueryForm
                  pageName="CPA"
                  courseId={1}
                  darkBackground={false}
                  submitButtonName="Request a Callback"
                  formType="Banner Form"
                  isAStepperForm
                  successMessage={SuccessMessageType.ACCOUNTING}
                  formHeading={FormHeading.TALK_TO_AN_EXPERT}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MilesCpaBanner;
